<template>
    <b-modal
        v-model="modal"
        title="Invoice"
        hide-footer
        centered
        @show="setData"
        @hidden="resetData"
    >
        <VueMonthlyPicker v-model="selectedMonth"> </VueMonthlyPicker>
        <b-button variant="primary" class="mb-1" @click="onClickSubmit()">
            Submit
        </b-button>
    </b-modal>
</template>

<script>
import moment from 'moment';
import VueMonthlyPicker from 'vue-monthly-picker';

export default {
    name: 'InvoiceModal',
    components: { VueMonthlyPicker },
    props: {
        awsAccountUuid: {
            required: true,
        },
        value: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    computed: {
        modal: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
    },
    data() {
        return {
            selectedMonth: '',
        };
    },
    methods: {
        setData() {
            this.selectedMonth = moment(new Date());
        },
        resetData() {
            this.selectedMonth = moment(new Date());
        },
        onClickSubmit() {
            let route = this.$router.resolve({
                name: 'invoice',
                params: {
                    accountId: this.awsAccountUuid,
                    year: moment(this.selectedMonth).format('YYYY'),
                    month: moment(this.selectedMonth).format('M'),
                },
            });
            window.open(route.href, '_blank');
            this.modal = false;
        },
    },
};
</script>

<style scoped></style>
